import { connect } from 'react-redux'

import {
  trackPrintedRecipeCardClickRecipe,
  trackPrintedRecipeCardClickDone,
  trackPrintedRecipeCardClickCookbook,
} from '../../actions/recipeCards'
import { getSelectedAddress } from '../../selectors/addressSelectors'
import { getSelectedRecipeCardsDetails } from '../../selectors/recipesSelectors'
import { RecipeCardConfirmation } from './RecipeCardConfirmation'

const mapStateToProps = (state) => ({
  selectedAddress: getSelectedAddress(state),
  recipeCardsDetails: getSelectedRecipeCardsDetails(state),
})

const RecipeCardConfirmationContainer = connect(mapStateToProps, {
  trackPrintedRecipeCardClickRecipe,
  trackPrintedRecipeCardClickDone,
  trackPrintedRecipeCardClickCookbook,
})(RecipeCardConfirmation)

export { RecipeCardConfirmationContainer }
